<template>
  <section class="ja">
    <b-main
      v-if="job"
      type="submit"
      class="ja__button"
      :title="buttonTitle"
      :active="!isDisableApply"
      @click="onApply"
    />
  </section>
</template>

<script>
import MainButton from '../button/mainButton'
import { sendApplyJobClickEvent } from '../.././libs/tracking/utils/event'

export default {
  components: {
    'b-main': MainButton,
  },
  computed: {
    buttonTitle() {
      if (this.job.is_applied) {
        return this.$t('apply.applied')
      } else if (this.job.is_closed || this.job.is_suspended) {
        return this.$t('apply.expired')
      }
      return this.$t('apply.apply')
    },
    isDisableApply() {
      return !this.job || this.job.is_applied || this.job.is_closed || this.job.is_suspended
    },
  },
  methods: {
    onApply() {
      sendApplyJobClickEvent(this.$eventTracker, this.job._id)
      this.$router.push({
        path: this.localePathName('/apply'),
        query: {
          id: this.job._id,
        },
      })
    },
  },
  props: {
    job: {
      default: null,
      type: Object,
    },
  },
}
</script>

<style lang="postcss" scoped>
.ja {
  @apply flex justify-center items-center relative w-full h-ja z-1;
  @apply sticky bottom-0;
}
.ja__button {
  width: 272px;
}
</style>
